export default __webpack_public_path__ + "static/media/CX_loading_circle_white.a44d7198.svg";